/* ============================================================================
   DRIVE IQ — SIGNALS V200
   PASSIVE DRIVER SIGNAL / REPORT PROVIDER

   PURPOSE
   - Capture driver road reports using the canonical live GPS fix.
   - Persist those reports for Incident IQ.
   - Expose the legacy DRIVE_IQ_SIGNALS API.
   - Never own map layers, camera, route geometry, reroute, voice, session
     lifecycle, page navigation, or background polling.

   ACTIVE AUTHORITY
   - drive-iq-drive-mode.js owns navigation.
   - drive-iq-incident-awareness.js owns passive incident visualization.
   - This file only creates/report signals.

   HARD RULES
   - No setInterval.
   - No map.addLayer / Marker ownership.
   - No route mutation.
   - No Horizon/Route IQ overwrite loops.
   - No reload/navigation.
   ============================================================================ */

(function(window,document){
"use strict";

if(window.__DRIVE_IQ_SIGNALS_V200_PASSIVE__){ return; }
window.__DRIVE_IQ_SIGNALS_V200_PASSIVE__ = true;

var BUILD = "SIGNALS_V200_PASSIVE_PROVIDER";

var LS = {
  DRIVER_SIGNAL:"diq_driver_signal_v1",
  COMMUNITY_SIGNALS:"diq_community_signals_v1",
  LAST_SIGNAL:"diq_last_signal_v1",
  USER_ROAD_REPORTS:"diq_user_road_reports_v1"
};

function now(){ return Date.now ? Date.now() : new Date().getTime(); }
function clean(v){ return String(v == null ? "" : v).replace(/\s+/g," ").trim(); }
function finite(v){ v=Number(v); return isFinite(v); }
function safeParse(v){ try{return JSON.parse(String(v||""));}catch(e){return null;} }
function lsGet(k){ try{return localStorage.getItem(k);}catch(e){return null;} }
function lsJSON(k,v){ try{localStorage.setItem(k,JSON.stringify(v));return true;}catch(e){return false;} }

function toast(text){
  try{
    var el=document.getElementById("diqToast");
    if(!el){return;}
    el.textContent=clean(text)||"Ready";
    el.classList.add("show");
    window.clearTimeout(el.__diqSignalTimer);
    el.__diqSignalTimer=window.setTimeout(function(){el.classList.remove("show");},1500);
  }catch(e){}
}

function bridge(){
  return window.DRIVE_IQ_SIGNAL_BRIDGE || null;
}

function getFix(){
  var b=bridge(),fix=null;
  try{
    if(b && typeof b.getFix==="function"){
      fix=b.getFix();
      if(fix && finite(fix.lat) && finite(fix.lng)){return fix;}
    }
  }catch(e1){}

  try{
    if(window.DRIVE_IQ_DRIVE_MODE && typeof window.DRIVE_IQ_DRIVE_MODE.getFix==="function"){
      fix=window.DRIVE_IQ_DRIVE_MODE.getFix();
      if(fix && finite(fix.lat) && finite(fix.lng)){return fix;}
    }
  }catch(e2){}

  fix=safeParse(lsGet("diq_last_gps_v1"));
  return fix && finite(fix.lat) && finite(fix.lng) ? fix : null;
}

function getDestination(){
  var dest=null;
  try{
    if(window.DRIVE_IQ_DRIVE_MODE && typeof window.DRIVE_IQ_DRIVE_MODE.getDestination==="function"){
      dest=window.DRIVE_IQ_DRIVE_MODE.getDestination();
      if(dest){return dest;}
    }
  }catch(e){}
  return safeParse(lsGet("diq_dest_v1"));
}

function normalizeType(type){
  var s=clean(type||"other").toLowerCase();

  if(/police|cop|speed trap|speed/.test(s)){return "police";}
  if(/crash|accident|wreck/.test(s)){return "crash";}
  if(/road.?closed|closure|closed/.test(s)){return "road_closed";}
  if(/exit.?blocked|blocked exit/.test(s)){return "exit_blocked";}
  if(/debris|object|hazard/.test(s)){return "hazard";}
  if(/shoulder|vehicle/.test(s)){return "vehicle_on_shoulder";}
  if(/slow|traffic|jam/.test(s)){return "slowdown";}
  if(/construction|lane shift|work zone/.test(s)){return "construction";}
  if(/weather|rain|storm|fog|ice/.test(s)){return "weather_hazard";}
  if(/bad detour/.test(s)){return "bad_detour";}
  if(/no signs/.test(s)){return "no_signs";}
  if(/police directing/.test(s)){return "police_directing";}
  if(/road|issue/.test(s)){return "road_issue";}

  return s.replace(/\s+/g,"_") || "other";
}

function labelFor(type){
  type=normalizeType(type);
  if(type==="police"){return "Police Reported";}
  if(type==="crash"){return "Crash";}
  if(type==="road_closed"){return "Road Closed";}
  if(type==="exit_blocked"){return "Exit Blocked";}
  if(type==="hazard"){return "Road Debris";}
  if(type==="vehicle_on_shoulder"){return "Vehicle on Shoulder";}
  if(type==="slowdown"){return "Slowdown";}
  if(type==="construction"){return "Construction";}
  if(type==="weather_hazard"){return "Weather Hazard";}
  if(type==="bad_detour"){return "Bad Detour";}
  if(type==="no_signs"){return "No Signs";}
  if(type==="police_directing"){return "Police Directing";}
  if(type==="road_issue"){return "Road Issue";}
  return "Road Signal";
}

function ttlHours(type){
  type=normalizeType(type);
  if(type==="road_closed"||type==="exit_blocked"){return 96;}
  if(type==="construction"){return 24;}
  if(type==="crash"){return 4;}
  if(type==="weather_hazard"){return 3;}
  return 2;
}

function buildSignal(type,label,note){
  var fix=getFix(),dest=getDestination(),t=normalizeType(type);
  if(!fix){return null;}

  return {
    id:"diq_signal_"+String(now()),
    type:t,
    label:clean(label||labelFor(t)),
    note:clean(note||""),
    lat:Number(fix.lat),
    lng:Number(fix.lng),
    heading:finite(fix.heading)?Number(fix.heading):null,
    speed:finite(fix.speedMph)?Number(fix.speedMph):(finite(fix.speed)?Number(fix.speed):0),
    accuracy:finite(fix.accuracy)?Number(fix.accuracy):(finite(fix.acc)?Number(fix.acc):null),
    destination:dest?{
      name:clean(dest.name||dest.label||"Destination"),
      lat:finite(dest.lat)?Number(dest.lat):null,
      lng:finite(dest.lng)?Number(dest.lng):null
    }:null,
    confidence:100,
    radius_miles:(t==="road_closed"||t==="exit_blocked")?1.0:0.55,
    created_at:new Date().toISOString(),
    expires_at:new Date(now()+ttlHours(t)*3600000).toISOString(),
    source:"driver_signal_iq_v200"
  };
}

function persistSignal(sig){
  var community=safeParse(lsGet(LS.COMMUNITY_SIGNALS));
  var reports=safeParse(lsGet(LS.USER_ROAD_REPORTS));

  if(!Array.isArray(community)){community=[];}
  if(!Array.isArray(reports)){reports=[];}

  community.push(sig);
  reports.push(sig);

  if(community.length>100){community=community.slice(-100);}
  if(reports.length>200){reports=reports.slice(-200);}

  lsJSON(LS.COMMUNITY_SIGNALS,community);
  lsJSON(LS.USER_ROAD_REPORTS,reports);
  lsJSON(LS.LAST_SIGNAL,sig);

  return true;
}

function report(type,label,note){
  var sig=buildSignal(type,label,note);
  var b=bridge();
  var handed=false;

  if(!sig){
    toast("GPS needed for road report");
    return false;
  }

  persistSignal(sig);

  /*
    If Drive Mode exposes the canonical report authority, hand the report to it.
    The bridge may normalize/publish it, but this provider never changes route,
    map, camera, voice, or session state.
  */
  try{
    if(b && typeof b.report==="function"){
      b.report(sig.type,sig.note||sig.label);
      handed=true;
    }else if(b && typeof b.saveSignal==="function"){
      b.saveSignal(sig);
      handed=true;
    }
  }catch(e1){}

  try{
    window.dispatchEvent(new CustomEvent("driveiq:signal-added",{
      detail:sig
    }));
  }catch(e2){}

  try{
    if(window.DIQ_INCIDENT_AWARENESS &&
       typeof window.DIQ_INCIDENT_AWARENESS.refresh==="function"){
      window.DIQ_INCIDENT_AWARENESS.refresh();
    }
  }catch(e3){}

  toast(sig.label+" reported");
  return sig;
}

function buildDriverPresence(){
  var fix=getFix(),dest=getDestination(),trip=lsGet("diq_active_drive_id_v1")||"";
  if(!fix){return null;}

  return {
    id:"driver_"+String(trip||"local"),
    type:"driver_presence",
    label:"Driver active",
    lat:Number(fix.lat),
    lng:Number(fix.lng),
    heading:finite(fix.heading)?Number(fix.heading):null,
    speed:finite(fix.speedMph)?Number(fix.speedMph):(finite(fix.speed)?Number(fix.speed):0),
    accuracy:finite(fix.accuracy)?Number(fix.accuracy):(finite(fix.acc)?Number(fix.acc):null),
    destination:dest||null,
    trip_id:String(trip||""),
    ts:now(),
    updated_at:new Date().toISOString(),
    expires_in_minutes:20,
    source:"drive_mode_v200"
  };
}

function publishDriverSignal(){
  var sig=buildDriverPresence();
  var b=bridge();

  if(!sig){return false;}

  lsJSON(LS.DRIVER_SIGNAL,sig);

  try{
    if(b && typeof b.saveSignal==="function"){
      b.saveSignal(sig);
    }
  }catch(e){}

  return true;
}

function getSignals(){
  var list=safeParse(lsGet(LS.COMMUNITY_SIGNALS));
  return Array.isArray(list)?list:[];
}

function clearLocalSignals(){
  lsJSON(LS.COMMUNITY_SIGNALS,[]);
  lsJSON(LS.USER_ROAD_REPORTS,[]);
  try{
    window.dispatchEvent(new CustomEvent("driveiq:incident-refresh"));
  }catch(e){}
  toast("Signals cleared");
  return true;
}

window.DRIVE_IQ_SIGNALS = {
  version:"v200-passive",
  build:BUILD,

  publish:publishDriverSignal,
  draw:function(){
    /*
      Compatibility no-op. Signal drawing belongs to Incident Awareness V200.
    */
    try{
      if(window.DIQ_INCIDENT_AWARENESS &&
         typeof window.DIQ_INCIDENT_AWARENESS.render==="function"){
        return window.DIQ_INCIDENT_AWARENESS.render();
      }
    }catch(e){}
    return false;
  },
  status:function(){
    var list=getSignals();
    return list.length?String(list.length)+" signals available":"Signals ready";
  },
  getSignals:getSignals,
  addSignal:function(type,label,note){return report(type,label,note);},
  clear:clearLocalSignals,

  addPolice:function(){return report("police","Police Reported","");},
  addSpeedTrap:function(){return report("police","Speed Trap","");},
  addShoulder:function(){return report("vehicle_on_shoulder","Vehicle on Shoulder","");},
  addCrash:function(){return report("crash","Crash","");},
  addSlowdown:function(){return report("slowdown","Slowdown","");},
  addRoadDebris:function(){return report("hazard","Road Debris","");},
  addWeather:function(){return report("weather_hazard","Weather Hazard","");},
  addRoadClosed:function(){return report("road_closed","Road Closed","");},
  addExitBlocked:function(){return report("exit_blocked","Exit Blocked","");},
  addBadDetour:function(){return report("bad_detour","Bad Detour","");},
  addNoSigns:function(){return report("no_signs","No Signs","");},
  addLaneShift:function(){return report("construction","Lane Shift","");},
  addPoliceDirecting:function(){return report("police_directing","Police Directing","");},
  addConstruction:function(){return report("construction","Construction","");},
  addRoad:function(){return report("road_issue","Road Issue","");},
  addRoadIssue:function(){return report("road_issue","Road Issue","");},

  /* Legacy names retained so old buttons do not throw. */
  addHazard:function(){return report("hazard","Hazard","");},
  addParking:function(){return report("parking","Parking","");},
  addWellness:function(){return report("wellness","Wellness","");},
  addShopping:function(){return report("shopping","Shopping","");},
  addScenic:function(){return report("scenic","Scenic","");},
  addOther:function(){return report("other","Road Signal","");}
};

window.DRIVE_IQ_DROP_SIGNALS = window.DRIVE_IQ_SIGNALS;

try{
  console.log("✅ Drive IQ Signals V200 passive provider loaded",BUILD);
}catch(e){}

})(window,document);
